module.exports = __webpack_public_path__ + "img/ad4a2e36dc99789570f008e3f7bc870f.0d8fc855.webp";